import React, { useState, useMemo } from 'react';
import { getCountrysApi } from '../../services/authApi/userApi';
import { toastNotify } from '../../utils/toastNotify';
import { Select, Spin, Form } from 'antd';
import { ChevronDown, ChevronUp } from '../../assets/icons';
import FloatingLabel from '../FloatingLabel/FloatingLabel';

const CountrySeeder = (props) => {
  const { setCountry, country, isEdit, required } = props;
  const [countryLoader, setCountryLoader] = useState(false);
  const [countryDataList, setCountryDataList] = useState([]);
  const [totalCountry, setTotalCountry] = useState(0);
  const [countryPage, setCountryPage] = useState(1);
  const [arrowUp, setArrowUp] = useState(false);
  const fetchCountryData = async (page) => {
    setCountryLoader(true);
    const paginationData = {
      page: page,
      perPage: 10,
    };
    try {
      const resp = await getCountrysApi(paginationData);
      if (!resp.isError) {
        setTotalCountry(resp?.data?.count);
        resp?.data?.countries?.map((item) => setCountryDataList((prevItem) => [...prevItem, item]));
      } else {
        toastNotify('error', resp?.message);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setCountryLoader(false);
    }
  };

  useMemo(() => fetchCountryData(countryPage), []);

  const incrementPagination = () => {
    setCountryPage((countryPage) => countryPage + 1);
    fetchCountryData(countryPage + 1);
  };
  return (
    <FloatingLabel label='Country' inputId='country' isEdit={isEdit} name='identification' inputValue={country}>
      <>
        <div id='country-seeder-anchor' />
        <Form.Item name='country' rules={[{ required: required, message: 'Please select state' }]}>
          <Select
            id='country'
            onPopupScroll={(e) => {
              let target = e.target;
              if (target.scrollTop + target.offsetHeight === target.scrollHeight && totalCountry !== countryDataList.length && !countryLoader) {
                incrementPagination();
              }
            }}
            onChange={(value) => setCountry(value)}
            value={country}
            getPopupContainer={() => document.getElementById('country-seeder-anchor')}
            onDropdownVisibleChange={() => setArrowUp(!arrowUp)}
            suffixIcon={arrowUp ? <ChevronUp color='#1A1519' /> : <ChevronDown color='#1A1519' />}
          >
            {countryDataList.length > 0 &&
              countryDataList.map((data, index) => (
                <Select.Option key={index} value={data?.countryId}>
                  {data?.name}
                </Select.Option>
              ))}
            {countryLoader && (
              <Select.Option disabled>
                <Spin className='ant-spin--centered' />
              </Select.Option>
            )}
          </Select>
        </Form.Item>
      </>
    </FloatingLabel>
  );
};

export default CountrySeeder;
